import ARB from 'assets/chains/ARB.svg'
import AVAX from 'assets/chains/AVAX.svg'
import ETH from 'assets/chains/ETH.svg'
import NOBLE from 'assets/chains/NOBLE.svg'
import JOLTIFY from 'assets/chains/JOLTIFY.svg'

export const CHAIN_ICONS = {
  ETH,
  AVAX,
  ARB,
  NOBLE,
  JOLTIFY
}
